<template>
  <div class="header" id="home-header">
    <div class="header-content">
      <div class="header-logo">
        <img :src="static_img_url+'pic/logo-vcbeat.png?v='+ $store.state.version" @click="returnIndex">
      </div>
      <div class="header-navigation">
        <Poptip trigger="hover">
          <div slot="content" class="code-list">
            <div class="code-item">
              <img :src="static_img_url + 'pic/download-code.png'" />
              <p>扫码下载</p>
            </div>
          </div>
          <div class="nav-item">动脉网APP</div>
        </Poptip>
        <div :class="['nav-item']" @click="handleChangeRoute('LinkList', 1)">
          <img class="icon-img" :src="$store.state.static_img_url + 'pic/new.png'" />
          <span>产业链接</span>
        </div>
        <Poptip trigger="hover">
          <div slot="content" class="code-list">
            <div class="code-item">
              <img :src="static_img_url + 'pic/vcbeat/ft_ewm_2.jpg'" />
              <p>动脉网公众号</p>
            </div>
            <div class="code-item">
              <img :src="static_img_url + 'pic/vcbeat/chengguoju.jpg'" />
              <p>动脉橙果局</p>
            </div>
            <div class="code-item">
              <img :src="static_img_url + 'pic/vcbeat/chanyezhiku.png'" />
              <p>动脉橙产业智库</p>
            </div>
            <div class="code-item">
              <img :src="static_img_url + 'pic/vcbeat/xinyiyao.jpg'" />
              <p>动脉新医药</p>
            </div>
          </div>
          <div class="nav-item">公众号矩阵</div>
        </Poptip>
        <div :class="['nav-item', $route.name == 'VBResearch' && 'on']" @click="handleChangeRoute('VBResearch', 1)">蛋壳研究院</div>
        <div :class="['nav-item']" @click="handleChangeRoute('searchTrack', 1)">动脉橙产业智库</div>
        <Dropdown @on-visible-change="activity_visible = !activity_visible" @on-click="handleChangeRoute($event, 1)">
          <div class="nav-item" :class="[activity_visible && 'visible']">
            <span>活动</span>
            <Icon type="ios-arrow-down"></Icon>
          </div>
          <DropdownMenu slot="list">
            <DropdownItem name="VBEF">未来医疗生态展会</DropdownItem>
            <DropdownItem name="VB100">VB100官网</DropdownItem>
            <DropdownItem name="VB100List">VB100榜单</DropdownItem>
            <DropdownItem name="moreActivity">更多活动</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <div :class="['nav-item', $route.name == 'IndustrialSolutions' && 'on']" @click="handleChangeRoute('IndustrialSolutions', 1)">行业解决方案</div>
      </div>
      <div class="header-search">
        <div class="btn" @click="handleClickSearch">
          <i class="iconfont">&#xe6d7;</i>
          <span>搜索</span>
        </div>
      </div>
      <div class="header-user">
        <span v-if="!user_key" @click="showLogin" onclick="_czc.push(['_trackEvent', '顶部菜单(新)', '登录', '点击量'])">登录</span>
        <Dropdown v-else @on-click="clickDropDown" trigger="hover" placement="bottom-end" :transfer="true" transfer-class-name="usernavlist">
          <img :src="wx_image" v-if="wx_image" />
          <img :src="static_img_url+'pic/default_header.png'" v-else />
          <DropdownMenu slot="list">
            <DropdownItem name="collect"><i class="iconfont-sm">&#xe66e;</i><span>我的收藏</span></DropdownItem>
            <DropdownItem name="order"><i class="iconfont-sm">&#xe614;</i><span>订单管理</span></DropdownItem>
            <DropdownItem name="my_product"><i class="iconfont-sm">&#xe623;</i><span>已购产品</span></DropdownItem>
            <DropdownItem name="account"><i class="iconfont-sm">&#xe61e;</i><span>账号设置</span></DropdownItem>
            <DropdownItem name="quit"><i class="iconfont-sm">&#xe620;</i><span>退出</span></DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
    <!-- <Login :loginModal="loginModal" @logincancel="loginCancel"></Login> -->
    <LoginNew ref="login-new"></LoginNew>
    <SearchModal :searchModal="search_modal" @searchcancel="searchCancel"></SearchModal>

  </div>
</template>

<script>
import SearchModal from './SearchModal.vue'
import Login from './Login.vue'
import LoginNew from './LoginNew.vue'
import { mapState } from 'vuex'
import { loginOut } from '../service'
import Cookies from 'js-cookie'
export default {
  inject: ['haddleApplyTry2', 'reload'],

  components: {
    LoginNew,
    SearchModal,
  },
  data() {
    return {
      activity_visible: false,
      loginModal: false,
      search_modal: false,
      active_name: '',
    }
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      static_img_url: (state) => state.static_img_url,
      index_path: (state) => state.index_path,
      index2_path: (state) => state.index2_path,
      vbef_path: (state) => state.vbef_path,
    }),
    wx_image() {
      return this.$store.state.user.wx_avatarurl || this.$store.state.user.wxAvatarurl || ''
    },
    isShowNavigation() {
      const router_arr = ['Index', 'IntelDetail', 'IntelAuthor', 'LinkDetail']
      return router_arr.indexOf(this.$route.name) > -1
    },
  },
  methods: {
    handleChangeRoute(name, new_open = 0) {
      let href
      switch (name) {
        case 'VBEF':
          href = this.vbef_path + '/forum/2024'
          break
        case 'LinkList':
          href = this.index2_path + '/linkList'
          break
        case 'VBResearch':
          href = this.index2_path + '/VBResearch'
          break
        case 'IndustrialSolutions':
          href = this.index2_path + '/IndustrialSolutions'
          break
        case 'searchTrack':
          href = this.index_path + '/searchTrack'
          break
        case 'VB100':
          href = 'https://vb100.vbdata.cn/'
          break
        case 'VB100List':
          href = 'https://vb100.vbdata.cn/list/'
          break
        case 'moreActivity':
          href = this.index2_path + '/Activity/activityList'
          break
      }

      if (new_open) window.open(href, '_blank')
      else window.location.href = href
    },
    clearModal2BodyStyle() {
      document.body.style.paddingRight = ''
      document.body.style.overflow = ''
    },
    showLogin() {
      // this.loginModal = !this.loginModal
      this.$refs['login-new'].modelIndex = true
    },
    loginCancel(value) {
      this.loginModal = value
      if (!value) {
        this.clearModal2BodyStyle()
      }
    },
    searchCancel(value) {
      this.search_modal = value
      if (!value) {
        this.clearModal2BodyStyle()
      }
    },
    returnIndex() {
      const href = this.index2_path
      window.location.href = href
    },
    async clickDropDown(name) {
      if (name == 'quit') {
        // 退出
        let res = await loginOut({ user_key: this.user_key }, (error) => {
          this.$Message.error('请求错误！')
        })
        if (res.status == 'success') {
          this.$Message.success('退出成功！')
          this.$store.commit('updateUser', '')
          this.$store.commit('updateUserKey', '')
          this.$store.commit('updateFilter', '')
          this.$store.commit('topicEntityCount', '')
          this.$store.commit('topicTagCount', '')
          this.$store.commit('updateIdentity', true)
          this.$store.commit('setUUserId', null)
          this.$store.commit('updateTiaojian', '')
          window.localStorage.removeItem('show_scientific')

          Cookies.remove('user_key_' + this.$store.state.cookie_type, {
            domain: this.$store.state.domain_path,
            path: '/',
          })

          this.reload()
        } else {
          this.$Message.error(res.message)
        }
      }
      if (name == 'coupon') {
        // 优惠券
        // this.$router.push({ name: 'UserCoupon' })
        let link = this.index_path + '/userCoupon'
        window.open(link)
      }
      if (name == 'order') {
        // 我的订单
        // this.$router.push({ name: 'OrderList' })
        let link = this.index_path + '/orderList'
        window.open(link)
      }
      if (name == 'my_product') {
        // 我的报告
        // this.$router.push({ name: 'UserProduct' })
        let link = this.index_path + '/userProduct'
        window.open(link)
      }
      if (name == 'account') {
        // 账号设置
        // this.$router.push({ name: 'UserAccount' })
        let link = this.index_path + '/userAccount'
        window.open(link)
      }
      if (name == 'collect') {
        // 收藏
        // this.$router.push({ name: 'Collect' })
        let link = this.index2_path + '/collect'
        window.open(link)
      }
    },
    handleClickSearch() {
      this.search_modal = !this.search_modal
      _czc.push(['_trackEvent', '顶部菜单(新)', '搜索', '点击量'])
    },
    activeName(name) {
      // 点击menuitem
      if (name == 'org-apply') {
        this.haddleApplyTry2(11)
      }
      if (name == 'data-src') {
        _czc.push(['_trackEvent', '顶部菜单(新)', '数据产品(动脉橙LOGO)', '点击量'])
        let link = this.index_path + '/searchTrack'
        window.open(link)
      }
    },
  },
  created() {},
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.header-content
  width 1200px
  height 64px
  margin 0 auto
  display flex
  .header-logo
    flex 0 0 114px
    max-width 114px
    min-width 114px
    font-size 0
    display flex
    align-items center
    img
      width 114px
      height 36px
      cursor pointer
  .header-navigation
    flex auto
    margin-left 60px
    display flex
    align-items center
    font-size 14px
    > div
      &+div
        margin-left 40px
    .nav-item
      color #333333
      cursor pointer
      display flex
      align-items center
      justify-content center
      transition all 0.3s
      font-size 16px
      position relative
      span
        &+i
          transition all 0.3s
          margin-left 4px
      .icon-img
        position absolute
        width 25px
        height 14px
        right -28px
        top -7px
      &.visible
        color #FF8824
        i
          transform rotate(180deg)
      &:hover, &.on
        color #FF8824
      &.disabled
        color #999999
        cursor not-allowed
        &:hover
          color #999999
    >>> .ivu-poptip
      .ivu-poptip-arrow
        display none
      .ivu-poptip-popper
        min-width auto
        padding 20px 0 7px 0
      .ivu-poptip-inner
        background-color none
        border-radius 0
        .ivu-poptip-body
          padding 0
    >>> .ivu-dropdown
      .ivu-select-dropdown
        padding 20px 0 5px
        margin 0
        border-radius 0
        box-shadow none
        background none
        .ivu-dropdown-menu
          box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
          background-color #fff
          padding 5px 0
          .ivu-dropdown-item
            color #333333
    .code-list
      display flex
      padding 20px 10px 10px
      background #F5F7F9
      .code-item
        display flex
        flex-direction column
        align-items center
        width 100px
        img
          width 80px
          height 80px
        p
          margin-top 7px
          font-size 12px
          font-weight 400
          color #333333
          line-height 17px
        & + div
          margin-left 10px
  .header-user
    flex 0 0 60px
    max-width 60px
    min-width 60px
    display flex
    justify-content center
    align-items center
    span
      display inline-block
      line-height 24px
      color #fff
      font-size 14px
      cursor pointer
      background-color #ff8824
      width 60px
      text-align center
      line-height 32px
      &:hover
        background-color #FF6600
    .default-header
      color #333333
      font-size 30px
      cursor pointer
    img
      width 30px
      height 30px
      border-radius 50%
      cursor pointer
  .header-search
    margin-right 20px
    display flex
    align-items center
    position relative
    .btn
      display flex
      align-items center
      white-space nowrap
      cursor pointer
      span, .iconfont
        color #FF8824
        font-size 16px
        transition all 0.2s
      .iconfont
        margin-right 4px
      &:hover
        span, .iconfont
          color #FF6600
.iconfont-sm
  inlineBlock()
  margin-right 12px
  font-size 18px
  color #999999
  vertical-align middle
</style>
